import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ToolbarItem from './ToolbarItem';

import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: 5,
  },
}));

const oppositeDirectionClass = {
  vertical:"sg-row",
  horizontal:"sg-col",
}

export default function PopoverToolbarItem({item,editorStyle,selectedFigureItems, unifiedGroup,setRetainInputFocus,className,scale,subToolbarDirection,panelGlobalStyle,figurePanelId,disabled,
  anchorOrigin,
  transformOrigin

}){

  let toolbarItemProps = {editorStyle,selectedFigureItems, unifiedGroup,setRetainInputFocus,className,scale,panelGlobalStyle};

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    console.log(event.currentTarget.getBoundingClientRect());
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    console.log("setting anchorEl to null!");
    setAnchorEl(null);
  };

  

  //console.log({iconType:typeof(item.icon)});

  const getIcon = () => {
    let icon = item.icon;
    if( typeof(icon) === 'function' ){
      if( !unifiedGroup.style ){
        //debugger;
      }
      return icon(unifiedGroup.style||{},selectedFigureItems);
    }else{
      return icon;
    }
    
  }

  const open = Boolean(anchorEl);

  if( open ){
    window.__handleMenuClose = handleClose;
  }



  const id = open ? 'simple-popover' : undefined;



  let currentDirection = item.subToolbarDirection;

  let subtoolbarClass = item.subToolbarDirection!=='vertical'?'sg-row':'sg-vert';

  if( item.styleProperty === "color" ){
  }

  let icon = getIcon();


  let containerClassName = `style-toolbar sg-row hoverable toolbar-button ${open?"open-toolbar-item":""}`


  let disabledStyles = disabled ? ({
    opacity:0.5,
    pointerEvents:'none',

  }):{}

  return (

    <>
      <div 
        onClick={handleClick}
        class={containerClassName} style={{alignItems:'center', padding:4,borderRadius:5,
          ...disabledStyles,



        }}>

        {item.hint && icon && <Tooltip title={item.hint}>
          {icon}
          </Tooltip>}
      {!item.hint && item.icon}
        {false && <ArrowDropDownIcon style={{width:15,height:15}}/>}
      </div>

      {open && <Popover
        style={{
          zIndex:100000
        }}
        className={"style-toolbar"}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
          ...(anchorOrigin||{})
        }}
        transitionDuration={0}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
          ...(transformOrigin||{})
        }}
      >
        <Typography className={classes.typography}>
          <div class={subtoolbarClass}>
            {item.subToolbar.map( subToolbarItem => {

              if( Array.isArray( subToolbarItem ) ){
                return (
                  <div class={"sg-row"}>
                    {subToolbarItem.map(subsubItem => {
                      return <ToolbarItem {
                        ...{...toolbarItemProps,
                          item:subsubItem}
                        }/>
                    })}
                  </div>
                )
              }else{
                return <ToolbarItem 
                  {...{
                    figurePanelId,
                    item:subToolbarItem,
                    ...toolbarItemProps
                  }}
                  />
              }

            })}
          </div>

          
        </Typography>
      </Popover>}

    </>
  )

}

